import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import type { Config } from '..';
import content from '../../../../.contentlayer/generated/PrivacyPolicy/privacyPolicy__fr-FR.mdx.json';

export const config: Config = {
  layout: { ...sharedConfig['fr-FR'].layout },
  seo: {
    ...sharedConfig['fr-FR'].seo,
    title: 'Confidentialite • Lemonade Insurance FR',
    metaTitle: 'Confidentialite • Lemonade Insurance FR',
    description:
      'Découvrez comment Lemonade collecte, utilise et protège vos données personnelles en consultant notre politique de confidentialité en France.',
  },
  MDXContent: content as DocumentTypes,
};
